var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShowLayouts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20L21 5L3 5L3 20L21 20ZM4.12079 18.7837L4.12079 6.21631L19.8799 6.21631L19.8799 18.7837L4.12079 18.7837Z",
    fill: "#99C540"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 20L11.1 13L3 13L3 20L11.1 20ZM3.50436 19.4324L3.50436 13.5676L10.596 13.5676L10.596 19.4324L3.50436 19.4324Z",
    fill: "#99C540"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShowLayouts);
export default __webpack_public_path__ + "static/media/icon_show_layouts.630704f06d22fe537be178c38ae7f4d2.svg";
export { ForwardRef as ReactComponent };